import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetTransactionItem  {
    _originalTypeClassName = "zERP.BO.AssetTransactionItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetTransactionItem.translate = translateService;
}
this.Transaction = new Domain.AssetTransaction();
this.Asset = new Domain.Asset();
this.Id = null;
this.TransactionSerialNumber = null;
this.CreatedAt = null;
this.Description = null;
this.PreTransactionSalvageValue = null;
this.CurrentSalvageValue = null;
this.DepreciationRate = null;
this.DepreciationValue = null;
this.ExpansionNotes = null;
this.IsTotalDestructionOrSale = false;
this.PartialDestructionOrSalePercent = null;
this.DestructionOrSaleDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TransactionSerialNumber:any;
CreatedAt:any;
Description:any;
PreTransactionSalvageValue:any;
CurrentSalvageValue:any;
DepreciationRate:any;
DepreciationValue:any;
ExpansionNotes:any;
IsTotalDestructionOrSale:any;
PartialDestructionOrSalePercent:any;
DestructionOrSaleDate:any;
Transaction:any;
Asset:any;
TransactionDocumentDetail:any;
static setTransaction = ($this, value) => {
var oldValue = $this.Transaction;
$this.Transaction = value;
if (value != null) {
if (oldValue != null) {
Domain.AssetTransaction.removeItems(oldValue, $this);
}
Domain.AssetTransaction.addItems(value, $this);
}
}
static setAsset = ($this, value) => {
var oldValue = $this.Asset;
$this.Asset = value;
if (value != null) {
}
}
static setTransactionDocumentDetail = ($this, value) => {
var oldValue = $this.TransactionDocumentDetail;
$this.TransactionDocumentDetail = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}